/**
 * RBAC helpers. Only Reviewer, PM, or Admin can "finalize" (approve, set user shared, use for editing).
 */
export function canFinalize(user) {
  const role = user?.role || user?.app_metadata?.role;
  return ['admin', 'pm', 'reviewer'].includes(role);
}
